







    import Vue, { PropOptions } from 'Vue';
    import Vuex from 'Vuex';
    import Vuetify from 'Vuetify';
    import VueRoute from 'Vue-Router';
    import { IPreviewColour } from '../../../../../../CommonScripts/Abstractions';

    export default Vue.extend({
        name: 'mgr-colour-picker',
        props: {
            colour: { type: Object as () => IPreviewColour, required: true } as PropOptions<IPreviewColour>
        },
        computed: {
            rgbColour(): any {
                return this.colour;
            }
        },
        methods: {
            updated(newValue: any): void {
                this.$emit('changed', { r: newValue.rgba.r, g: newValue.rgba.g, b: newValue.rgba.b, a: newValue.rgba.a, });
            }
        }
    });
